const scoringRuleActions = {
    BACKUP : 'backup',

    CREATE : 'create',

    COPY : 'copy',

    DELETE : 'delete',

    DISCARD : 'discard',

    SAVE : 'save'

};

angular.module('gw-um-j2js')
    .constant('scoringRuleActions', scoringRuleActions);